import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c42261c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row gy-5 g-xl-8" }
const _hoisted_2 = { class: "col-lg-3" }
const _hoisted_3 = { class: "card card-inicio mb-5 mb-xxl-8 w-100" }
const _hoisted_4 = { class: "card-body pt-9 pb-0" }
const _hoisted_5 = { class: "h-50" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-wrap flex-sm-nowrap mb-3 border-bottom\" data-v-5c42261c><div class=\"me-7\" data-v-5c42261c><div class=\"symbol symbol-50px symbol-fixed symbol-circle position-relative\" data-v-5c42261c><img class=\"border border-2 border-azul\" src=\"media/avatars/blank.png\" alt=\"image\" data-v-5c42261c></div></div><div class=\"flex-grow-1\" data-v-5c42261c><div class=\"d-flex justify-content-between align-items-start flex-wrap mb-2\" data-v-5c42261c><div class=\"d-flex flex-column\" data-v-5c42261c><div class=\"d-flex align-items-center\" data-v-5c42261c><a href=\"#\" class=\"texto-gris-1 fs-2 me-1\" data-v-5c42261c>Max Smith</a></div><div class=\"d-flex flex-wrap pe-2\" data-v-5c42261c><a href=\"#\" class=\"d-flex align-items-center text-blue me-5 mb-2\" data-v-5c42261c> Administrador </a></div></div></div></div></div>", 1)
const _hoisted_7 = { class: "overflow-auto" }
const _hoisted_8 = { class: "nav-stretch nav-tabs border-transparent p-0 flex-nowrap" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 me-3" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"31px"},
    class: "`bi bi-person-circle fs-1 text-muted`"
  })
], -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Perfil ")
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 me-3" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"31px"},
    class: "`bi bi-hdd fs-1 text-muted`"
  })
], -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Mis equipos ")
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 me-3" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"31px"},
    class: "`bi bi-file-richtext fs-1 text-muted`"
  })
], -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Bitacora ")
const _hoisted_18 = { class: "nav-item d-block pe-6" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "informes d-flex" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 me-3" }, [
    /*#__PURE__*/_createElementVNode("i", {
      style: {"font-size":"31px"},
      class: "`bi bi-clipboard-data fs-1 text-muted`"
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Informes")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 0,
  class: "px-3 py-4 despliegueInformes"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" -Informes programables ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" -Descargar informe ")
const _hoisted_25 = { class: "nav-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 me-3" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"31px"},
    class: "`bi bi-people-fill fs-1 text-muted`"
  })
], -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Mis grupos ")
const _hoisted_28 = { class: "d-flex align-items-end h-50" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-left text-blue fs-1" }, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Cerrar sesión ")
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { class: "col-lg-9" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-lg-4 col-sm-12 pb-5" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column my-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder text-blue" }, "Mis ubicaciones")
], -1))
const _hoisted_36 = { class: "col-lg-4 col-sm-12" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column my-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder text-blue" }, "Reportes pendientes por leer")
], -1))
const _hoisted_38 = { class: "col-lg-4 col-sm-12" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column my-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder text-blue" }, "Equipos en alerta")
], -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder text-blue my-3" }, "Últimos informes creados")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ListLocations = _resolveComponent("ListLocations")!
  const _component_ReportsToRead = _resolveComponent("ReportsToRead")!
  const _component_equipmentAlert = _resolveComponent("equipmentAlert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("ul", _hoisted_8, [
                _createElementVNode("li", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    to: { name: 'profile-overview' },
                    class: "nav-link me-6 w-100 rounded-pill",
                    "active-class": "active",
                    style: {"font-size":"16px","color":"#999999"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      _hoisted_11
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_12, [
                  _createVNode(_component_router_link, {
                    to: { name: 'profile-equipos' },
                    class: "nav-link me-6 w-100 rounded-pill",
                    "active-class": "active",
                    style: {"font-size":"16px","color":"#999999"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_15, [
                  _createVNode(_component_router_link, {
                    to: { name: 'profile-campaigns' },
                    class: "nav-link me-6 w-100 rounded-pill",
                    "active-class": "active",
                    style: {"font-size":"16px","color":"#999999"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16,
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_18, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["nav-link me-6 py-3 w-100 d-flex justify-content-between bottonInformes", { active: _ctx.mostrar }]),
                    "active-class": "active",
                    style: {"font-size":"16px"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.despliegueInformes && _ctx.despliegueInformes(...args)))
                  }, _hoisted_21, 2),
                  (_ctx.mostrar == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_router_link, {
                            to: { name: 'profile-informes' },
                            class: "nav-link me-6 w-100 text-white rounded-pill px-10",
                            "active-class": "active",
                            style: {"font-size":"16px","border-color":"transparent !important"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_23
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_router_link, {
                            to: { name: 'descargar-informe' },
                            class: "nav-link me-6 w-100 text-white rounded-pill px-10",
                            "active-class": "active",
                            style: {"font-size":"16px","border-color":"transparent !important"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_24
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("li", _hoisted_25, [
                  _createVNode(_component_router_link, {
                    to: { name: 'profile-mi-grupo' },
                    class: "nav-link me-6 w-100 rounded-pill",
                    "active-class": "active",
                    style: {"font-size":"16px","color":"#999999"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_26,
                      _hoisted_27
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              class: "btn bg-white fw-normal border-top w-100 text-start align-items-center px-0 mb-3",
              style: {"font-size":"16px","color":"#999999"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.signOut()))
            }, _hoisted_31)
          ])
        ])
      ]),
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createVNode(_component_ListLocations, { style: {"max-height":"400px"} })
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createVNode(_component_ReportsToRead, { "widget-classes": "overflow-auto" })
        ]),
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createVNode(_component_equipmentAlert, { "widget-classes": "mb-5 overflow-auto" })
        ]),
        _hoisted_40
      ])
    ])
  ]))
}